import React from 'react';
import { motion } from 'framer-motion';
import { Scale, AlertCircle, Truck, RefreshCw } from 'lucide-react';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-black pt-28 pb-12 px-6">
            <div className="max-w-4xl mx-auto space-y-12">
                {/* Header */}
                <div className="text-center space-y-4">
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-4xl md:text-5xl font-serif font-bold text-gradient"
                    >
                        Terms of Service
                    </motion.h1>
                    <p className="text-gray-400">Last Updated: December 2025</p>
                </div>

                {/* Content Card */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="glass-card p-8 md:p-12 rounded-2xl space-y-8"
                >
                    <Section
                        icon={<Scale className="w-6 h-6 text-gold-500" />}
                        title="1. Acceptance of Terms"
                        content="By accessing our website and placing orders, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services. We reserve the right to modify these terms at any time."
                    />

                    <Section
                        icon={<Truck className="w-6 h-6 text-gold-500" />}
                        title="2. Orders & Delivery"
                        content="All orders are subject to availability. Delivery times are estimates and may vary due to traffic, weather, or kitchen load. We reserve the right to refuse service to anyone for any reason at any time."
                    />

                    <Section
                        icon={<RefreshCw className="w-6 h-6 text-gold-500" />}
                        title="3. Refund & Cancellation Policy"
                        content="Orders cannot be cancelled once the kitchen has started preparation (usually within 5 minutes of placement). If you receive a wrong or defective item, please contact us immediately for a replacement or refund. Refunds are processed at the sole discretion of management."
                    />

                    <Section
                        icon={<AlertCircle className="w-6 h-6 text-gold-500" />}
                        title="4. User Conduct"
                        content="You agree not to misuse our services, including but not limited to: submitting false orders, using abusive language with our staff, or attempting to breach our security systems. Violation of these rules may result in permanent refusal of service and blocking of your delivery address/phone number."
                    />

                    <div className="pt-8 border-t border-white/10">
                        <h3 className="text-gold-400 font-bold text-lg mb-2">Legal Disclaimer</h3>
                        <p className="text-gray-400">Our services are provided 'as is' without warranties of any kind. We are not liable for any damages arising from your use of our website or services.</p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

const Section = ({ icon, title, content }) => (
    <div className="space-y-3">
        <div className="flex items-center gap-3">
            {icon}
            <h2 className="text-xl font-bold text-white">{title}</h2>
        </div>
        <p className="text-gray-400 leading-relaxed pl-9">
            {content}
        </p>
    </div>
);

export default TermsOfService;
